import React from 'react';
import HomologacionesHabilitacionesCuantitativasTable from './TableHomologacionesHabilitacionesCuantitativas/HomologacionesHabilitacionesCuantitativas';

const HomologacionesHabilitacionesCuantitativas = () => {
  return <HomologacionesHabilitacionesCuantitativasTable/> ;
};

export default HomologacionesHabilitacionesCuantitativas;
